import { FC } from 'react';

import { HowToVote } from '@mui/icons-material';
import { Modal, Box, Paper, Typography, Button, Fade } from '@mui/material';

export interface VotingModalProps {
  open: boolean;
  voteOption: string;
  handleClose: () => void;
  handleVote: () => void;
}

export const VotingModal: FC<VotingModalProps> = ({ open, voteOption, handleClose, handleVote }) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropProps={{
        timeout: 100,
      }}
    >
      <Fade in={open}>
        <Box
          sx={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: { xs: 0, md: 4 },
            userSelect: 'none',
          }}
        >
          <Paper
            elevation={12}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              margin: { xs: 0, md: 3 },
              maxHeight: '100%',
              outline: 'none',
              width: '100%',
              maxWidth: 400,
            }}
          >
            <Box
              sx={{
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                p: 3,
              }}
            >
              <HowToVote sx={{ width: 32, height: 32 }} />
              <Typography variant="h5" sx={{ ml: 1 }}>
                Confirm your Vote
              </Typography>
            </Box>
            <Box
              sx={{
                p: 3,
                flexGrow: 1,
                overflow: 'auto',
                textAlign: 'center',
              }}
            >
              <Typography variant="body2" sx={{ mb: 1 }}>
                You are voting on
              </Typography>
              <Typography variant="body1" fontWeight="bold">
                "{voteOption}"
              </Typography>
            </Box>

            <Box
              sx={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'space-evenly',
                p: 3,
              }}
            >
              <Button variant="outlined" onClick={handleClose}>
                Cancel
              </Button>
              <Button variant="contained" onClick={handleVote}>
                Vote
              </Button>
            </Box>
          </Paper>
        </Box>
      </Fade>
    </Modal>
  );
};
